import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const getCardEmbedUrl = async (
  paymentCardId: string,
  pathToCSS: string
): Promise<cardApiSpec.GetEmbedUrlResponse> => {
  const { data } = await cardsService.get(`${paymentCardId}/embed_url`, {
    params: {
      css: pathToCSS
    }
  });

  return data;
};
